var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemps1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.33 238.875L51.48 162.505L51.6699 22.4452L183.53 98.8152L183.33 238.875Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.46 143.445L51.6099 67.0752L51.6699 22.4452L183.53 98.8152L183.46 143.445Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6398 103.795L61.8398 91.1652L61.8698 70.0852L83.6698 82.7152L83.6398 103.795Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.48 121.075L91.6699 108.445L91.7 87.3651L113.5 99.9951L113.48 121.075Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.31 138.355L121.51 125.725L121.54 104.645L143.34 117.275L143.31 138.355Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.15 155.635L151.34 143.005L151.37 121.925L173.18 134.555L173.15 155.635Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5999 130.605L61.7998 117.975L61.8298 96.8951L83.6298 109.525L83.5999 130.605Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.44 147.875L91.6299 135.255L91.6599 114.175L113.47 126.805L113.44 147.875Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.27 165.155L121.47 152.535L121.5 131.455L143.3 144.085L143.27 165.155Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M173.11 182.445L151.31 169.815L151.34 148.735L173.14 161.365L173.11 182.445Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5698 157.415L61.7598 144.785L61.7898 123.695L83.5999 136.325L83.5698 157.415Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.4 174.695L91.6001 162.065L91.63 140.985L113.43 153.605L113.4 174.695Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 191.975L121.43 179.345L121.46 158.265L143.27 170.885L143.24 191.975Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.84 89.4052L183.53 98.8152L183.33 238.875L199.65 229.465L199.84 89.4052Z",
    fill: "#29A063"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.98 13.035L51.6699 22.4451L183.53 98.8151L199.84 89.405L67.98 13.035Z",
    fill: "#72D09A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.3 112.855C147.07 109.825 142.82 102.455 142.83 96.4151L142.85 80.405C142.85 77.385 143.92 75.265 145.64 74.285C147.36 73.295 149.73 73.4451 152.35 74.9551C157.58 77.9851 161.83 85.355 161.82 91.395L161.8 107.405C161.8 110.425 160.73 112.535 159.01 113.525C157.29 114.515 154.91 114.365 152.3 112.855Z",
    fill: "#72D09A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.99 75.7151C188.99 69.6851 184.75 62.305 179.52 59.275C176.9 57.755 174.52 57.615 172.8 58.605L151.09 71.155L145.64 74.285C147.36 73.295 149.73 73.4451 152.35 74.9551C157.58 77.9851 161.83 85.355 161.82 91.395L161.8 107.405C161.8 110.425 160.73 112.535 159.01 113.525L164.47 110.385C166.19 109.395 167.26 107.275 167.26 104.265L167.28 88.265V89.395L183.58 79.975L188.99 83.115V76.855V75.725V75.7151Z",
    fill: "#29A063"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9001 66.3251C66.6701 63.2951 62.4302 55.925 62.4302 49.895L62.4502 33.885C62.4502 30.865 63.5201 28.745 65.2401 27.765C66.9601 26.775 69.3302 26.9251 71.9502 28.4351C77.1802 31.4651 81.4302 38.835 81.4202 44.875L81.4001 60.885C81.4001 63.895 80.3301 66.015 78.6101 67.005C76.8901 67.995 74.5101 67.8451 71.9001 66.3351V66.3251Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1202 12.7451C96.5002 11.2251 94.1203 11.0851 92.4003 12.0751L70.6903 24.6251L65.2402 27.7551C66.9602 26.7651 69.3303 26.9151 71.9503 28.4251C77.1803 31.4551 81.4303 38.825 81.4203 44.865L81.4003 60.8751C81.4003 63.8851 80.3302 66.0051 78.6102 66.9951L84.0703 63.855C85.7903 62.865 86.8502 60.745 86.8602 57.735L86.8802 42.855L103.18 33.4351L108.59 36.5952V29.1651C108.6 23.1351 104.35 15.755 99.1202 12.725V12.7451Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemps1);
export default __webpack_public_path__ + "static/media/temps1.641fcc21dd5bfae1dedeea1a6eaa146c.svg";
export { ForwardRef as ReactComponent };